module.exports = __webpack_public_path__ + "img/ntm_live.82d00380.jpg";